__turbopack_context__.v({
  "button_Wrapper": "mlEH9q_button_Wrapper",
  "card": "mlEH9q_card",
  "medical-dashboard-submit-button": "mlEH9q_medical-dashboard-submit-button",
  "trav_age": "mlEH9q_trav_age",
  "trav_details": "mlEH9q_trav_details",
  "trav_med_conditions": "mlEH9q_trav_med_conditions",
  "trav_name": "mlEH9q_trav_name",
});
